export default {
  text: 'Verificar com {{provider}}',
  text_generic: 'Verificar com o seu fornecedor de pagamentos',
  error: 'Não foi possível abrir o formulário do {{provider}}. Tente novamente.',
  error_generic: 'Não foi possível abrir o formulário do fornecedor de pagamentos. Tente novamente.',
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
};
